import React from "react";
import PropTypes from "prop-types";
import { PrimaryButton, ButtonLink } from "../../../../components/Buttons";

import {
  W3Dropdown,
  W3DropdownToggler,
  W3DropdownContent,
} from "../../../../components/W3Dropdown";
import ITTaskDialog from "./ITTaskDialog";
import ActionFilter from "../ActionFilter";
import { filterTasksByTaskType, isDeletionTask } from "../Utils";

export default function ANPConnectionTaskMenu({
  className = "",
  items = [],
  selectedANPConnections,
  exportANPConnections,
  closeANPConnections,
  filterConnections,
  connectionTaskType,
}) {
  const taskDialogRef = React.useRef(null);

  const onExport = React.useCallback(
    (event) => {
      if (event) event.preventDefault();
      const type = "ANP";
      let counter = 0;
      if (selectedANPConnections && selectedANPConnections.length > 0) {
        counter += selectedANPConnections.length;
      }
      const isSingular = counter === 1;
      taskDialogRef.current.show(
        true,
        {
          title: `AN-Portal Zugänge exportieren`,
          text: `
          ${isSingular ? "Der" : "Alle " + counter} ausgewählte AN-Portal ${isSingular ? "Zugang wird" : "Zugänge werden"} für die  
          Weiterverarbeitung vorbereitet und als CSV exportiert. Wollen Sie fortfahren?
        `,
          type: type.toUpperCase(),
          showValidity: false,
          taskType: connectionTaskType,
          showTaskType: false,
        },
        (data) => exportANPConnections(data),
      );
    },
    [selectedANPConnections, exportANPConnections, connectionTaskType],
  );

  const closeableConnections = React.useMemo(() => {
    if (selectedANPConnections) {
      return selectedANPConnections.filter((item) =>
        filterTasksByTaskType(item, connectionTaskType),
      );
    }
    return [];
  }, [connectionTaskType, selectedANPConnections]);

  const onClose = React.useCallback(
    (event) => {
      if (event) event.preventDefault();
      const type = "ANP";
      let counter = 0;
      if (selectedANPConnections && selectedANPConnections.length > 0) {
        counter += selectedANPConnections.length;
      }
      const isSingular = counter === 1;
      taskDialogRef.current.show(
        true,
        {
          title: `AN-Portal Zugänge schließen`,
          text: `
          ${isSingular ? "Der" : "Alle " + counter} ausgewählte AN-Portal ${isSingular ? "Zugang wird" : "Zugänge werden"} nun geschlossen.  
          Wollen Sie fortfahren?
        `,
          type: type.toUpperCase(),
          showValidity: false,
          taskType: connectionTaskType,
          showTaskType: false,
        },
        (_data) => closeANPConnections(closeableConnections),
      );
    },
    [closeableConnections, connectionTaskType],
  );

  const isANPExportable = selectedANPConnections && selectedANPConnections.length > 0;
  const isCloseable = closeableConnections && closeableConnections.length > 0;

  return (
    <div className={className}>
      <div className="w3-cell-row">
        <div className="w3-cell w3-cell-middle pad-rht">
          <ActionFilter
            type="ANP"
            taskType={connectionTaskType}
            setTaskType={filterConnections}
            itemsToCount={items}
            className="display-inline-block"
          />
        </div>
        <div className="w3-cell w3-cell-middle pad-lft">
          <W3Dropdown className="modems dropdown-list-menu">
            <W3DropdownToggler as={PrimaryButton} size="">
              {`Optionen`}
            </W3DropdownToggler>
            <W3DropdownContent
              className="w3-bar-block w3-border"
              style={{ right: "0", width: "320px" }}
            >
              <ButtonLink
                to="#"
                className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
                onClick={onExport}
                disabled={!isANPExportable}
              >
                {`AN-Portal Zugänge exportieren (CSV)`}
              </ButtonLink>
              {/* <ButtonLink
                className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
                to={`/wizard/aufgabe/import/anportal-account`}
                disabled={false}
              >
                {`AN-Portal Zugänge importieren (CSV)`}
              </ButtonLink> */}
              <a href="#" className="w3-bar-item separator">
                <div className="w3-border-top" style={{ margin: "0 -4px" }} />
              </a>
              <ButtonLink
                to="#"
                className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
                onClick={onClose}
                disabled={!isCloseable}
              >
                {`AN-Portal Zugänge schließen`}
              </ButtonLink>
            </W3DropdownContent>
          </W3Dropdown>
        </div>
      </div>
      <ITTaskDialog ref={taskDialogRef} />
    </div>
  );
}

ANPConnectionTaskMenu.propTypes = {
  className: PropTypes.string,
  selectedANPConnections: PropTypes.array,
  connectionTaskType: PropTypes.string,
  exportANPConnections: PropTypes.func.isRequired,
  filterConnections: PropTypes.func.isRequired,
  closeANPConnections: PropTypes.func.isRequired,
  items: PropTypes.array,
  history: PropTypes.object,
};
